/* 
*  Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. 
*  See LICENSE in the source repository root for complete license information. 
*/

import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import * as hello from 'hellojs/dist/hello.all.js';
import * as MicrosoftGraphClient from "@microsoft/microsoft-graph-client";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  public get client(): MicrosoftGraphClient.Client {
    let client = MicrosoftGraphClient.Client.init({
        authProvider: (done) => {
            console.log('Client graph')
            done(null, this.getAccessToken());
        }
    });
    console.log('client');
    console.log(client);
    return client;
  }

  public getMe(): Observable<any> {
    return new Observable(obs => {
        this.client.api('me').get().then(res => {
            console.log('GetMe')
          console.log(res)

            obs.next(res);
            obs.complete();
        });
    });
  }


  getAccessToken() {
    const msft = hello('msft').getAuthResponse();
    const accessToken = msft.access_token;
    return accessToken;
  }

  login(){
   return hello().login();
  }


}
